import React, { useState, useEffect, useRef } from "react";
import { Box, Snackbar, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCustomerDropdown,
} from "../../Actions/DeviceComponent.js";
import {
  fetAllFloorData
} from "../../Actions/FloorManagementAction.js";
import AddEditFloor from "./AddEditFloor";
import DeleteModal from "./DeleteModal";
import Table from "../Table";
import SubHeader from "../SubHeader";

import {
  decodeUserAccess,
  processFloorData,
  handleDeleteUtility,
  handleToastCloseUtility,
  handleEditUtility,
  downloadBlueprintUtility,
  getFloorColumns,
  goToAddDevicesUtility,
} from "../../utils/floorManagementUtils.js";

import "./style.scss";
import FloorFilter from "./FloorFilter.js";

const FloorManagement = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const token = JSON.parse(localStorage.getItem("token"));
  const [hasData, setHasData] = useState(true);
  const [selectedEditId, setSelectedEditid] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [openToast, setOpenToast] = useState(false);
  const [message, setMessage] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [actionButton, setActionButton] = useState("");
  const {
    deviceFiltersSuccess,
  } = useSelector((state) => state.deviceComponent);

  useEffect(() => {
    dispatch(fetchCustomerDropdown());
  }, [dispatch]);
  const [editData, setEditData] = useState(null);
  const [filters, setFilters] = useState({
    floorName: "",
  });
  const [page, setPage] = useState(1);
  const [deviceIdToDelete, setDeviceIdToDelete] = useState(null);

  const navigate = useNavigate();
  const createFloorBtnRef = useRef(null);

  const { data, isLoading } = useSelector(
    (state) => state.FloorManagementReducer
  );

  const { edit, canDelete, view, create } = decodeUserAccess(token);
  const processedRows = processFloorData(data?.content);

  // useEffect(() => {
  //   fetchFloorsUtility(dispatch);
  // }, [dispatch, actionButton]);

  const handleEdit = (row, id) => {
    handleEditUtility(
      setSelectedEditid,
      setEditData,
      setActionButton,
      setOpen,
      row,
      id
    );
  };

  const handleRequestDelete = (id) => {
    setOpenDeleteModal(true);
    setDeviceIdToDelete(id);
  };

  const handleView = (id) => {
    goToAddDevicesUtility(dispatch, navigate, id);
  };

  const handleDownload = (id) => {
    downloadBlueprintUtility(dispatch, id);
  };

  const columns = getFloorColumns({
    edit,
    canDelete,
    view,
    onEdit: handleEdit,
    onRequestDelete: handleRequestDelete,
    onView: handleView,
    onDownload: handleDownload,
  });

  const handleDelete = (id) =>
    handleDeleteUtility(dispatch, id, setOpenToast, setMessage, createFloorBtnRef, filters);

  const handleToastClose = () => handleToastCloseUtility(setOpenToast, setMessage);

  useEffect(() => {
    if (createFloorBtnRef.current) {
      createFloorBtnRef.current.focus();
    }
  }, []);

  const SORT_FIELD_MAP = {
    floor: "name",
    buildingId: "buildingId",
  };

  useEffect(() => {
      if (data?.content) {
        setTotalPages(data.totalPages);
      }
    }, [isLoading]);

   useEffect(() => {
      dispatch(
        fetAllFloorData({
          customerNames: filters.customerNames,
          buildingId: filters.buildingId,
          floorName: filters.floorName,
          isDeleted: false,
          typeIds: filters.typeIds,
          page: page - 1,
          size: 5,
          ...(filters?.sort && {
            sortBy: SORT_FIELD_MAP[filters.sort.field] || filters.sort.field,
            sortDirection: filters.sort.order,
          }),
        })
      );
    }, [filters, page, dispatch]);

  return (
    <>
      <span className="sr-only" role="status" aria-live="polite" aria-atomic="true">
        {!hasData
          ? "No data available"
          : `${processedRows.length} item${processedRows.length > 1 ? "s" : ""} found`}
      </span>

      <main
        className="main_ele_wrapper userMangement_wrapper"
        role="main"
        aria-label="Floor Management Section"
      >
        <SubHeader
          heading="Floor Management"
          headerButton={
            create && (
              <div
                className="AddUser new-entry"
                data-testid="add-floor-button-wrapper"
              >
                <button
                  name="Create-New-Floor"
                  className="addDevice"
                  ref={createFloorBtnRef}
                  onClick={() => {
                    setOpen(true);
                    setActionButton("add");
                  }}
                >
                  Add Floor
                </button>
              </div>
            )
          }
        />

        <div className="new-EntryForMobile">
          {create && (
            <div
              className="AddUser new-entry"
              data-testid="add-user-button-wrapper"
            >
              <button
                name="Create-New-User"
                className="containedButton"
                onClick={() => {
                  setOpen(true);
                  setActionButton("add");
                }}
                aria-label="Create new user"
              >
                Add Floor
              </button>
            </div>
          )}
        </div>

        <FloorFilter
          filters={filters}
          setFilters={setFilters}
          page={page}
          setPage={setPage}
          onClear={() => {
            setFilters({ customerNames: [], buildingId: [], floorName: [], deviceType: [] });
            setPage(1);
          }}
          floorOptions={deviceFiltersSuccess?.floors?.map(
            (floor) => floor.name
          )}
          deviceTypeOption={deviceFiltersSuccess?.deviceType?.map(
            (floor) => floor.name
          )}
        />

        <div className="inner_Wrapper">
          <div className="floorMangementTable_wrapper">
            {isLoading && processedRows.length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Box sx={{ width: "100%" }}>
                <Table
                  columns={columns}
                  rows={processedRows}
                  setHasData={setHasData}
                  page={page}
                  totalPages={totalPages}
                  onPageChange={setPage}
                  onSortChange={(value) => {
                    setFilters((filter) => ({
                      ...filter,
                      sort: value,
                    }));
                  }}
                />
              </Box>
            )}
          </div>
        </div>
      </main>

      <AddEditFloor
        open={open}
        setOpen={setOpen}
        setActionButton={setActionButton}
        actionButton={actionButton}
        editData={editData}
        filters={filters}
        handleClose={() => {
          setTimeout(() => {
            if (selectedEditId && document.getElementById(selectedEditId)) {
              document.getElementById(selectedEditId).focus();
            } else if (createFloorBtnRef.current) {
              createFloorBtnRef.current.focus();
            }
          }, 300);
        }}
      />

      <DeleteModal
        setOpenDeleteModal={setOpenDeleteModal}
        openDeleteModal={openDeleteModal}
        handleDelete={() => handleDelete(deviceIdToDelete)}
      />

      <Snackbar
        open={openToast}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        message={message}
        onClose={handleToastClose}
        className="success"
      />
    </>
  );
};

export default FloorManagement;
